module.exports = __webpack_public_path__ + "static/img/bshwq.29d921f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bshwq.png
// module id = LpXh
// module chunks = 1